import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomBolderCheck({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.365 17a.9.9 0 01-.644-.274L.266 11.101a.96.96 0 010-1.326.89.89 0 011.286 0l4.811 4.962L18.448 2.274a.89.89 0 011.286 0 .96.96 0 010 1.326L7.005 16.726a.892.892 0 01-.644.274h.004z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomBolderCheck;
